import { css } from '@emotion/react';
import styled from '@emotion/styled';
import type { ComponentType, ReactNode } from 'react';
import { Variables } from '../base';
import { Card } from '../card/card.styles';
import { Title } from '../card/title-card.styles';

export const claimSectionTitleCss = css`
    margin: 0;
    font-family: ${Variables.Fonts.calibre};
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    color: ${Variables.ThemeLight.TextMedium};
`;

export const styledTitleCardSectionTitle = css`
    ${Title} {
        ${claimSectionTitleCss}
    }
`;

type ClaimDetailsPanelCardProps = {
    size: 'small' | 'medium' | 'large';
    children?: ReactNode;
};

const ClaimDetailsPanelBase = Card as ComponentType<ClaimDetailsPanelCardProps>;

export const ClaimDetailsPanel = styled(ClaimDetailsPanelBase)`
    display: flex;
    flex-direction: column;
    padding: 24px 0;
    width: 100%;
    background-color: ${Variables.Swatches.Gray1};
    border-radius: 12px;
`;

export const ClaimSectionBlock = styled.section`
    &:not(:first-of-type) {
        position: relative;
        margin-top: 24px;
        padding-top: 24px;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 24px;
            right: 24px;
            height: 1px;
            background-color: ${Variables.ThemeLight.Border2};
        }
    }
`;

export const ClaimSectionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin: 0 24px 14px;
`;

export const ClaimSectionTitle = styled.h2`
    ${claimSectionTitleCss}
`;
